import { render, staticRenderFns } from "./menu-entry-table.vue?vue&type=template&id=58b6f360&scoped=true&"
import script from "./menu-entry-table.ts?vue&type=script&lang=ts&"
export * from "./menu-entry-table.ts?vue&type=script&lang=ts&"
import style0 from "./menu-entry-table.scss?vue&type=style&index=0&id=58b6f360&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b6f360",
  null
  
)

export default component.exports